const data = {};

data.point = {
  data: {
    code: 0, // success
    message: 'success',
    data: {
      pointName: 'HIT2 포인트',
      pointUnitName: 'p',
      // point: null, // 정산중
      point: 1000000,
      // expiryPoint: null, // 정산중
      expiryPoint: 2310,
      njPointEnable: true,
    },
  },
};
data.pointHistory = {
  data: {
    code: 0,
    message: 'success',
    data: {
      totalCount: 21,
      totalPageCount: 2,
      pageNo: 1,
      pageSize: 20,
      list: [
        {
          content: {
            // 포인트 소멸 (크리에이터 탈퇴)
            chargeTypeName: 'lostPoint',
            extraInfo: null,
            regDate: null,
          },
          expiryDate: null,
          regDate: '2023.03.06 11:09:20',
          pointStatus: 2,
          pointStatusName: '사용',
          point: 50000.0,
        },
        // 적립 케이스
        {
          content: {
            // 충전) 포인트 적립 > 53 - 운영으로 인한 이관 적립
            chargeTypeName: 'pointTransferOperations',
            extraInfo: null,
            regDate: '2023.04.12',
          },
          expiryDate: null,
          regDate: '2023.04.14 15:28:06 (UTC +9)',
          pointStatus: 1,
          pointStatusName: '적립',
          point: 50000.0,
        },
        {
          content: {
            // 충전) 포인트 적립 > 54 - 명의변경
            chargeTypeName: 'pointTransferAccountHolderChange',
            extraInfo: null,
            regDate: '2023.04.12',
          },
          expiryDate: null,
          regDate: '2023.04.14 15:28:06 (UTC +9)',
          pointStatus: 1,
          pointStatusName: '적립',
          point: 50000.0,
        },
        {
          content: {
            // 넥슨 크리에이터즈 후원(167f238f-e905-40e9-8c52-33dfb9110737)
            chargeTypeName: 'earn',
            extraInfo: '넥슨 크리에이터즈 후원',
            regDate: null,
          },
          expiryDate: '2023.09.01 00:00:00',
          regDate: '2023.03.06 11:07:25 (UTC +9)',
          pointStatus: 1,
          pointStatusName: '적립',
          point: 50000.0,
        },
        {
          content: {
            // 개인 포인트 잔액 출금
            chargeTypeName: 'withdrawPersonBalance',
            extraInfo: null,
            regDate: null,
          },
          expiryDate: null,
          regDate: '2023.03.03 12:00:07 (UTC +9)',
          pointStatus: 2,
          pointStatusName: '사용',
          point: 50000.0,
        },
        {
          content: {
            // 사업자 2023년 3월 정기 수익
            chargeTypeName: 'businessRegularProfit',
            extraInfo: null,
            regDate: '2023.03.03',
          },
          expiryDate: null,
          regDate: '2023.03.03 11:51:42 (UTC +9)',
          pointStatus: 2,
          pointStatusName: '사용',
          point: 50000.0,
        },
        // 취소 케이스
        {
          // (마이너스 충전) 포인트 차감
          content: {
            // 포인트 전환신청 (2023.04.12신청) 지급취소
            chargeTypeName: 'creatorSanction',
            extraInfo: null,
            regDate: '2023.04.12',
          },
          expiryDate: null,
          regDate: '2023.04.14 15:28:06 (UTC +9)',
          pointStatus: 2,
          pointStatusName: '취소',
          point: 50000.0,
        },
        // {
        //   // (마이너스 충전) 포인트 차감 27 - 환불로 인한 적립 취소
        //   content: {
        //     // 포인트 전환신청 (2023.04.12신청) 지급취소
        //     chargeTypeName: 'cancelChargeByRefund',
        //     extraInfo: null,
        //     regDate: '2023.04.12',
        //   },
        //   expiryDate: null,
        //   regDate: '2023.04.14 15:28:06 (UTC +9)',
        //   pointStatus: 2,
        //   pointStatusName: '취소',
        //   point: 50000.0,
        // },
        {
          // (마이너스 충전) 포인트 차감 54 - 명의변경
          content: {
            // 포인트 전환신청 (2023.04.12신청) 지급취소
            chargeTypeName: 'pointTransferAccountHolderChange',
            extraInfo: null,
            regDate: '2023.04.12',
          },
          expiryDate: null,
          regDate: '2023.04.14 15:28:06 (UTC +9)',
          pointStatus: 2,
          pointStatusName: '취소',
          point: 50000.0,
        },
        {
          content: {
            // 포인트 전환신청 (2023.04.12신청) 지급취소
            chargeTypeName: 'cancelRequestExchangePoint',
            extraInfo: null,
            regDate: '2023.04.12',
          },
          expiryDate: null,
          regDate: '2023.04.14 15:28:06 (UTC +9)',
          pointStatus: 2,
          pointStatusName: '취소',
          point: 50000.0,
        },
      ],
    },
    debug: null,
  },
};

export default {
  ...data,
};
